
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "L’avantage d’un rédacteur professionnel pour votre site Web",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous n’avez pas de connaissances en programmation informatique et avez sollicité un développeur pour créer votre site Internet.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "L’avantage d’un rédacteur professionnel pour votre site Web",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous n’avez pas de connaissances en programmation informatique et avez sollicité un développeur pour créer votre site Internet.",
        },
      ],
    };
  },
};
